import Cards from "./components/Cards"
import SwitcherCards from "./components/SwitcherCards"

export { Cards as default, SwitcherCards }


// WEBPACK FOOTER //
// ./assets/common/components/ProfileCards/index.js